import { Link } from "react-router-dom";
import Icon from "../../../Icons/menu/Icon";
import PropTypes from 'prop-types';
import clsx from "clsx";

function MenuItem({ item, expand }) {
    const solapa = (e, id) => {
       let li = document.getElementById(e.currentTarget.id).parentNode;
       if (li)
       {
         let ul = document.getElementById(`ul${id}`);
         if (ul){
               let icon = document.getElementById(`chevrondown${id}`);
              if (ul.classList.contains('hidden'))
              {
                ul.classList.remove('hidden')
                if (icon)
                  icon.classList.add('rotate-180')
              }
              else{  
                ul.classList.add('hidden');
                if (icon)
                  icon.classList.remove('rotate-180')
              }
            }
          }
        }

    return (
           <li className='flex flex-col items-center text-sm  text-textsidebar' key={item.MenuId} id={item.MenuId}>
                <div id={`span${item.MenuId}`} className={`flex flex-row w-full group hover:cursor-pointer hover:text-list`} onClick={(e)=>item.CtnHijos ==="SI" ? solapa(e, item.MenuId): ({})} > 
                    {item.Icon && 
                        (<i className="flex-none w-8" >
                            <Icon svg={item.Icon}  className="w-4 h-4 md:w-6 md:h-6 fill-current text-textsiddebar group-hover:cursor-pointer group-hover:text-list" title={item.Icon} />
                         </i>
                        )
                    }
                    {item.CtnHijos !=='SI' ? 
                       ( <Link className={clsx('grow min-h-[1.0rem] md:min-h-[1.5rem] ',item.TipoMenu ===2 ? ' text-[0.65rem] md:text-textmenu pl-4' :'text-[0.9rem] pl-0', (item.PadreId ?? 0) === 0 ? 'pl-0':'')} to={item.Ruta}>
                            <span className={clsx('grow transition-all duration-200', expand ? 'opacity-100 w-auto' : 'opacity-0 w-0')}>
                                {item.NombreMenu}
                            </span>  
                          </Link>
                        )
                        :(
                           <span className={clsx('grow transition-all duration-200 min-h-[1.5rem]',
                                                  item.TipoMenu ===2 ? 'text-[0.65rem] md:text-textmenu pl-4':'text-[0.9rem]',
                                                  expand ? 'opacity-100 w-auto' : 'opacity-0 w-0', (item.PadreId ?? 0) === 0 && 'pl-0')} >
                                {item.NombreMenu}
                           </span>  
                         )
                    }
                    {item.CtnHijos ==='SI' &&
                        (<i className={clsx("flex-none w-2 md:w-4",(item.PadreId ?? 0) === 0 && 'mt-[0.4rem]')} id={`chevrondown${item.MenuId} `} >
                            <Icon svg="chevrondown"  className={clsx('w-2 h-2 md:w-3 md:h-3 items-center fill-current text-textsidebar rotate-0 group-hover:text-list group-hover:cursor-pointer',expand ? 'opacity-100 w-auto' : 'opacity-0 w-0')} title="chevrondown" />
                         </i>)}                                    
                </div>

                 {item.hijos.length > 0 && (
                      <ul className="flex-col w-full pl-4 text-xs hidden" id={`ul${item.MenuId}`}>
                           {item.hijos.map(hijo => (
                               <MenuItem key={hijo.MenuId} item={hijo} expand={expand}/>
                           ))}
                        </ul>
                  )}
            </li>
          );        
}
MenuItem.propTypes = {
  expand: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
 };

export default MenuItem;
